module.exports = "<div class=\"row swView\">\n\t<div class=\"small-8 columns swPane swPane--primary\"> \n\t\t<div *ngIf=\"document\" class=\"swCard\">\n\n\t\t\t<h1>{{document.name}}</h1>\n\n\t\t\t<p>ID: {{document.id}}</p>\n\t\t\t<p>Beskrivelse: {{document.description}}</p>\n\n\t\t\t<hr style=\"max-width: none;\">\n\t\t\t<input type=\"text\" value=\"{{document.name}}\" [(ngModel)]=\"document.name\">\n\t\t\t<input type=\"text\" value=\"{{document.description}}\" [(ngModel)]=\"document.description\">\n\n\t\t</div>\n\t</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/document/document.component.html
// module id = ./src/app/document/document.component.html
// module chunks = main